module.exports = __webpack_public_path__ + "static/bintang1-ef390abd5fc85636d5c7dca28bad5c73.mp4";